import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { UtilityFunctions } from '../utility/utils';
import { MessageService } from 'primeng/api';


@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  constructor(
    private _snackBar: MatSnackBar,
    public utility:UtilityFunctions,
    private messageService: MessageService
  ) { }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, { duration: 3 * 1000 });
  }

  openSnackBarSuccess(message: string, action: string) {
    this._snackBar.open(message, action, { 
      duration: 3 * 1000, 
      panelClass: ['bg-success'] });
  }

  openSnackBarError(message: string, action: string) {
    this._snackBar.open(message, action, { 
      duration: 3 * 1000,
      panelClass:['bg-danger'] 
    });
  }

  openSnackBarInfo(message: string, action: string) {
    this._snackBar.open(message, action, { 
      duration: 3 * 1000, 
      panelClass: ['bg-info'] });
  }

  showSuccess(message:any) {
    this.messageService.add({severity:'success', summary: 'Success', detail:message});
  }

  showError(message:any) {
    this.messageService.add({severity:'error', summary: 'Error', detail:message});
  }

  showInfo(message:any) {
    this.messageService.add({severity:'info', summary: 'Info', detail:message});
  }

  showWarning(message:any) {
    this.messageService.add({severity:'warn', summary: 'Warning', detail:message});
  } 

}
